// src/constants/roles.js

export const ROLES = {
  ADMIN: 1,
  AGENT: 2,
  MERCHANT: 3,
  SUPPORT: 4,
};

export const AccessControl = {
  DASHBOARD: [ROLES.ADMIN, ROLES.AGENT, ROLES.MERCHANT, ROLES.SUPPORT],
  BRANDS: [ROLES.ADMIN, ROLES.AGENT],
  MERCHANTS: [ROLES.ADMIN, ROLES.AGENT, ROLES.SUPPORT],
  EDIT_MERCHANTS: [ROLES.ADMIN],
  ADD_MERCHANTS: [ROLES.ADMIN],
  VIEW_MERCHANTS: [ROLES.ADMIN, ROLES.AGENT, ROLES.SUPPORT],
  MERCHANTS_TOPUP: [ROLES.ADMIN],
  MERCHANT_REQUESTS: [ROLES.ADMIN, ROLES.AGENT],
  MERCHANTS_AGREEMENT_VIEW: [ROLES.MERCHANT],
  MASTER_PRODUCT: [ROLES.ADMIN, ROLES.AGENT],
  PRODUCT: [ROLES.ADMIN, ROLES.AGENT],
  PROFILE: [ROLES.ADMIN, ROLES.AGENT, ROLES.MERCHANT, ROLES.SUPPORT],
  ORDERS: [ROLES.ADMIN, ROLES.AGENT, ROLES.MERCHANT, ROLES.SUPPORT],
  ADD_ORDERS: [ROLES.MERCHANT],
  CREATE_ORDER: [ROLES.ADMIN, ROLES.AGENT],
  REPORTS: [ROLES.ADMIN, ROLES.AGENT, ROLES.MERCHANT, ROLES.SUPPORT],
  ADMIN_AGENT: [ROLES.ADMIN],
  CUSTOMER_SUPPORT: [ROLES.ADMIN, ROLES.AGENT],
  BULK_UPLOAD: [ROLES.ADMIN],
  CUSTOMER_INFO: [ROLES.ADMIN, ROLES.AGENT],
  REGIONS: [ROLES.ADMIN],
  LOGS: [ROLES.ADMIN, ROLES.AGENT],
  PULL_REQUEST: [ROLES.ADMIN, ROLES.AGENT],
  DEVCO_DASHBOARD: [ROLES.ADMIN, ROLES.AGENT],
  STOCK_TRANSFER: [ROLES.ADMIN],
};
